<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryComprehensiveBusinessRecordResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" withCustomRowActions header-btn-edit-disabled header-btn-add-disabled
                                      :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                                      @linkClick="whenLinkClick">
                                <template #left-header>
                                    <em-button type="check" custom-icon="fa fa-fw fa-lg fa-link"
                                               custom-label="新增综合业务申请"
                                               show-name
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openComprehensiveBusinessDialog()"
                                    >
                                    </em-button>
                                </template>
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="gotoChild"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="gotoChild(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <comprehensive-business :comprehensiveBusinessDialogVisible="comprehensiveBusinessVisible" @change="change">
        </comprehensive-business>
    </div>
</template>
<script>
// Author lidongxu
// Date 2023-12-04 15:10:42

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import ComprehensiveBusiness from "@/components/SithMes/ComprehensivebusinessForm.vue";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emCommonApiMixin from "@/mixin/em/common/api";

export default {
    name: "sithMesInventoryComprehensiveBusinessRecordListView",
    components: {ComprehensiveBusiness},
    mixins: [emCommonListMixin, emCommonGotoMixin, emCommonApiMixin, emCustomVuexMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            comprehensiveBusinessVisible: false
        }
    },
    methods: {
        gotoChild(row) {
            this.$_emGotoMixin_gotoHolderList("sithMesInventoryComprehensiveBusinessDetail"
                    , {businessApplicationNoFilter: row.businessApplicationNo}
                    , {businessApplicationNo: row.businessApplicationNo}, false, {})
        },
        openComprehensiveBusinessDialog() {
            this.comprehensiveBusinessVisible = true;
        },
        change() {
            this.comprehensiveBusinessVisible = false;
        },
        whenLinkClick(key, row) {
            if (key === 'outdoorCertiNo') {
                this.$_emGotoMixin_gotoHolderList("sithMesInventoryOutdoorProcess"
                        , {codeFilter: row.outdoorCertiNo}
                        , {businessApplicationNo: row.businessApplicationNo}, false, {})
            }
            if (key === 'transportApplicationNo') {
                this.$_emGotoMixin_gotoHolderList("sithMesInventoryTransportApplication"
                        , {workOrderCodeFilter: row.transportApplicationNo}
                        , {workOrderCode: row.transportApplicationNo}, false, {})
            }
            if (key === 'deliveryNo') {
                this.$_emGotoMixin_gotoHolderList("sithMesInventoryDeliveryTask"
                        , {deliveryNoFilter: row.deliveryNo}
                        , {deliveryNo: row.deliveryNo}, false, {}, 'orderDeliveryTaskQuery'
                        , 'orderFilter','orderEntity', 'sithMesInventoryOrderDeliveryTaskList')
            }
            if (key === 'transferTicketNo') {
                this.$_emGotoMixin_gotoHolderList("sithMesStoolTransferTicketGenerationRecord"
                        , {transferTicketNoFilter: row.transferTicketNo}
                        , {transferTicketNo: row.transferTicketNo}, false, {})
            }
        },
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    }
};
</script>
